<template>
  <div class="common-detail-left-view">
    <div v-for="(group, index) in config.group" :key="index" class="group-item">
      <template v-if="!group.hide">
        <div v-if="group.label" class="group-title" @click="handleTitle(group)">
          {{group.label}}
          <span class="right">
            <span class="desc">{{group.desc}}</span>
            <i v-if="group.open" class="icon el-icon-arrow-up" :class="{'icon-open': group.open === 1}" />
          </span>
        </div>
        <div class="group-content" ref="content">
          <div v-if="group.column" class="content-box" :class="{hide: group.open === 2}" :style="getHideHeight(group)">
            <template v-for="(item, index) in group.column">
              <div v-if="item.display !== false" :key="item.prop || index" class="form-item" :style="getItemStyle(item)">
                <span class="label" v-if="item.label">{{item.label}}:</span>
                <span class="input-box">
                  <template v-if="item.slot === true">
                    <slot :name="`${item.prop}Slot`" :data="value" />
                  </template>
                  <el-tooltip v-else-if="item.tips" effect="dark" :content="getShowValue(item, value)" placement="top">
                    <div class="text-view">{{getShowValue(item, value)}}</div>
                  </el-tooltip>
                  <div v-else class="text-view" :class="{block: item.span === 0}">{{getShowValue(item, value)}}</div>
                </span>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {}
    }
  },
  props: {
    option: Object,
    value: Object,
    hidden: Boolean
  },
  computed: {
    labelWidth() {
      return this.option.labelWidth || 170
    }
  },
  watch: {
    option(option) {
      this.setConfig(option)
    }
  },
  created() {
    this.setConfig()
  },
  methods: {
    setConfig() {
      if (this.option.group) {
        this.config = this.option
      } else {
        this.config = {
          group: [
            {
              column: this.option.column
            }
          ]
        }
      }
    },
    handleTitle(group) {
      if (group.open) {
        group.open = group.open === 2 ? 1 : 2
      }
    },
    getItemStyle(item) {
      const css = {}
      if (item.span) {
        css.width = this.labelWidth * item.span + 'px'
      } else if (item.span === 0) {
        css.width = '100%'
      } else {
        css.width = this.labelWidth + 'px'
      }
      return css
    },
    getHideHeight(item) {
      if (item.hideHeight) {
        return {
          marginTop: item.open === 2 ? item.hideHeight : '0%'
        }
      }
      return {}
    },
    getShowValue(item, value = {}) {
      let val = ''
      if (item.formatter && typeof item.formatter === 'function') {
        val = item.formatter(value)
      } else {
        val = value[item.prop]
      }
      return (val || '--') + ''
    }
  }
}
</script>

<style lang="scss" scoped>
.common-detail-left-view {
  .group-item {
    margin-bottom: 10px;
    border: 1px solid #ddd;
    @include border-color('lighter');
    .group-title {
      font-size: 14px;
      line-height: 40px;
      color: #666;
      border-bottom: 1px solid #ddd;
      @include text-color('subtitle');
      @include border-color('lighter');
      @include bg-color('light');
      font-weight: 600;
      &::before {
        content: '';
        height: 12px;
        width: 2px;
        float: left;
        margin: 14px 0;
        margin-right: 10px;
        background-color: #666;
      }
      .right {
        float: right;
        font-size: 12px;
        font-weight: initial;
      }
      .icon {
        margin: 0 15px;
        transform: rotate(0);
        transition: 0.5s transform;
        &.icon-open {
          transform: rotate(180deg);
        }
      }
    }
    .group-content {
      margin-left: 20px;
      box-sizing: border-box;
      margin-bottom: -1px;
      overflow: hidden;

      .content-box {
        margin-top: 0%;
        transition: margin-top 0.5s;
        &.hide {
          margin-top: -100%;
        }
      }

      .form-item {
        box-sizing: border-box;
        float: left;
        padding-right: 20px;
        margin-top: 15px;
        // height: 24px;
        width: 170px;
        align-items: center;
        overflow: hidden;
        white-space: nowrap;

        &:last-child {
          margin-bottom: 15px;
        }
        &.block-item {
          width: 100%;
        }
        .label {
          display: block;
          white-space: nowrap;
          line-height: 24px;
          color: #999;
        }
        .input-box {
          width: 100%;
          height: 100%;
          line-height: 24px;
        }
        .text-view {
          // word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &.block {
            word-break: break-all;
            white-space: initial;
          }
        }
      }
    }
  }
}
</style>
